import { TWasmInteractionType } from "~/interfaces";
import WasmCustomMap from "../custom-map";
import WasmMapMarker from "../entities/wasm-map-marker";
import WasmMapMarkerSharedPosition from "../entities/wasm-map-marker-shared-position";
import { IWasmStoreMarker } from "../store/interfaces";
import { getMapContentCustomId, getWasmIntercationType } from "../utils";
import Wasm from "../wasm";
import { IEvents } from "./interfaces";

export default class WasmCustomMapMarker {
	#wasm: Wasm;

	#customMap: WasmCustomMap;

	#events: IEvents;

	#data: IWasmStoreMarker;

	#wasmMarker: WasmMapMarkerSharedPosition | WasmMapMarker;

	#origInteractionType: IWasmStoreMarker["interactionType"];

	constructor(opts: Partial<IWasmStoreMarker>) {
		this.#data = {
			id: getMapContentCustomId(),
			lon: 0,
			lat: 0,
			img: "",
			visual: "standard",
			draggable: false,
			lastChange: 0,
			bringToTheFront: false,
			type: "small",
			visible: true,
			customData: null,
			zIndex: null,
			angle: 0,
			interactionType: "none",
			...opts,
		};
		this.#customMap = null;
		this.#origInteractionType = this.#data.interactionType;
		this.#events = {};
	}

	get wasmIds() {
		return this.#wasmMarker
			? this.#wasmMarker.wasmIds
			: [];
	}

	create(wasm: Wasm, customMap: WasmCustomMap, events?: IEvents) {
		this.#wasm = wasm;
		this.#wasmMarker = wasm.createMarker(this.#data);
		this.#customMap = customMap;
		this.#events = events || {};
	}

	update(updData: Partial<IWasmStoreMarker>) {
		Object.assign(this.#data, updData);

		if (!this.#wasmMarker) {
			return;
		}

		if ("lon" in updData || "lat" in updData) {
			this.#wasmMarker.setPosition(this.#data.lon, this.#data.lat);
		}

		if ("visual" in updData) {
			this.#wasmMarker.setVisual(this.#data.visual);
		}

		if ("visible" in updData) {
			this.#wasmMarker.setVisibility(this.#data.visible);
		}

		if ("angle" in updData) {
			this.#wasmMarker.setAngle(this.#data.angle);
		}

		if ("bringToTheFront" in updData) {
			this.#wasmMarker.setBringToTheFront(this.#data.bringToTheFront);
		}

		if ("interactionType" in updData) {
			const interactionType: TWasmInteractionType = this.#data.interactionType === this.#origInteractionType
				? "none"
				: updData.interactionType;

			this.#suppresIds(interactionType);
		}
	}

	get id() {
		return this.#data.id;
	}

	get data() {
		return this.#data;
	}

	get events() {
		return this.#events;
	}

	destroy() {
		this.#wasmMarker?.destroy();
		this.#customMap?.onDelete("marker", this.#data.id, this.wasmIds);
	}

	#suppresIds(interactionType: TWasmInteractionType) {
		if (this.#wasm) {
			const wasmIds = this.#wasmMarker.wasmIds;

			this.#wasm.mapContent.suppressInteractionsFor(wasmIds, getWasmIntercationType(this.#wasm.module, interactionType));
		}
	}
}
